/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

'use strict';

angular.module('webReader')
    .directive('navigationBar', function () {
        return {
            scope: {

            },
            restrict: 'E',
            replace: true,
            templateUrl: 'directives/navigation-bar/navigation-bar.view.html',
            controller: ["$scope", "DocumentModel", "DocumentService", "$cookieStore", "$window", "NetworkService", "$timeout", "$sce", function ($scope, DocumentModel, DocumentService, $cookieStore, $window, NetworkService, $timeout, $sce) {
                let scope = $scope,
                    cookieStore = $cookieStore;

                let updatePageNumbers = function() {
                    let previousChaptersLength = 0,
                        pagesTotal = DocumentService.getTotalPagesCount(),
                        totalDocumentLength = DocumentModel.getTotalContentLength();

                    (function updatePageNumber(chapterCollection){
                        let chapterLength;

                        _.each(chapterCollection, function(el, i){
                            el.pageNumber = (pagesTotal * previousChaptersLength  / totalDocumentLength  + 1).toFixed(0);
                            previousChaptersLength = previousChaptersLength + DocumentModel.getChapterLength(DocumentModel.getChapterIdByUrl(el.url));

                            if (el.items) {
                                updatePageNumber(el.items);
                            }
                        });
                    })(scope.navigationItemsCollection);
                };

                scope.close = function($event){
                    if (!scope.isClosing ) {
                        scope.isClosing = true;
                        var bookPosition = DocumentService.getCurrentChapterOffsetObject();
                        console.log(bookPosition);
                        $event.stopPropagation();
                        $event.preventDefault();

                        DocumentService.changeSpinnerState(true);
                        NetworkService.updateToken().then(function () {
                            $timeout(function () {
                                if (!!bookPosition) {
                                    NetworkService.updateBookOffset(bookPosition, false).then(
                                        function () {
                                            window.location.href = '/browser/#access_token=' + cookieStore.get('accessToken') + '&refresh_token=' + cookieStore.get('refreshToken');
                                        }
                                    );
                                } else {
                                    window.location.href = '/browser/#access_token=' + cookieStore.get('accessToken') + '&refresh_token=' + cookieStore.get('refreshToken');
                                }
                            }, 200);
                        })
                    }
                };
                DocumentModel.subscribe.onModelUpdate(
                    function(){
                        scope.navigationItemsCollection = DocumentModel.getContentItems();
                        scope.tabsList = [
                            {
                                heading: 'contents',
                                content: '<chapterslist collection-node="params[0].navigationItemsCollection" ></chapterslist>',
                                params: { navigationItemsCollection: scope.navigationItemsCollection }
                            },
                            {
                                heading: 'notes',
                                content: '<notes-list></notes-list>',
                                params: {}
                            },
                            {
                                heading: 'bookmarks',
                                content: '<bookmarks-list></bookmarks-list>',
                                params: {}
                            },
                            {
                                heading: 'book info',
                                content: '<book-info></book-info>',
                                params: {}
                            },
                        ];
                    }
                );

                DocumentService.subscribe.onDocScrollRequested(function(params){
                   scope.shifted = false;
                });

                DocumentService.subscribe.onDocHeightChange(updatePageNumbers);
            }]
        };
    });